export default class MobileSlider {
	#rootDiv;
	#rootDivSelector;
	#state;
	#data;
	#youtubeUrl = "https://www.youtube.com/embed/";
	#defaultHeightSettings = {
		mobile: 250,
		tablet: 350,
	};

	constructor(
		srcObjectArray,
		rootDiv,
		rootDivSelector,
		customHeightSettings = {},
		mainSrcIndex = 0,
		animationSpeed = 250,
		quickAnimationSpeed = 100
	) {
		if (!(srcObjectArray instanceof Array))
			throw new TypeError("srcObjectArray must be of type Array");
		// if (!(rootDiv instanceof Element)) throw new TypeError("rootDiv must be of type Element")
		// if (!(typeof rootDivSelector === 'string' || rootDivSelector instanceof String)) throw new TypeError("rootDivSelector must be a string")
		this.#rootDiv = rootDiv;
		this.#rootDivSelector = rootDivSelector;
		this.#state = {
			isAnimating: false,
		};
		this.#data = {
			mainSrcIndex: mainSrcIndex,
			srcObjectArray: srcObjectArray,
			customHeightSettings: customHeightSettings,
			animationSpeed: animationSpeed,
			quickAnimationSpeed: quickAnimationSpeed,
			startActionTimestamp: 0,
			endActionTimestamp: 0,
		};
	}

	// getters

	get rootDiv() {
		return this.#rootDiv;
	}
	get rootDivSelector() {
		return this.#rootDivSelector;
	}
	get srcObjectArray() {
		return this.#data.srcObjectArray;
	}
	get sliderHeight() {
		return this.#getRequiredSliderHeight();
	}
	get animationSpeed() {
		return this.#data.animationSpeed;
	}
	get quickAnimationSpeed() {
		return this.#data.quickAnimationSpeed;
	}
	get mainSrcIndex() {
		return this.#data.mainSrcIndex;
	}
	get isAnimating() {
		return this.#state.isAnimating;
	}

	// setters

	set srcObjectArray(newArray) {
		this.#data.srcObjectArray = newArray;
	}
	set customHeightSettings(newVal) {
		this.#data.customHeightSettings = newVal;
	}
	set animationSpeed(newVal) {
		this.#data.animationSpeed = newVal;
	}
	set quickAnimationSpeed(newVal) {
		this.#data.quickAnimationSpeed = newVal;
	}

	// private methods

	#getGalleryMobileTemplate() {
		return `
        <div class="mobile-slider-wrapper slider-list-wrapper position-relative"
            style="visibility: hidden;"
        >

            <div class="slider-list d-flex flex-row animate"
                style="height: 100%; touch-action: manipulation; transform: ${this.#getTranslate3d(
									0
								)}">
                <div class="left-slide" style="background: rgb(25,25,25);">
                    <img style="display:none;" class="gallery-img left-img" alt="${
											lihe.name
										} - ${lihe.station}" src="" />
                    <iframe type="text/html" width="100%" height="100%" style="display:none;" class="left-iframe" src=""></iframe>
                </div>
                <div class="main-slide" style="background: rgb(25,25,25);">
                    <img style="display:none;" class="gallery-img main-img" alt="${
											lihe.name
										} - ${lihe.station}" src="" />
                    <iframe type="text/html" width="100%" height="100%" style="display:none;" class="main-iframe" src=""></iframe>
                </div>
                <div class="right-slide" style="background: rgb(25,25,25);">
                    <img style="display:none;" class="gallery-img right-img" alt="${
											lihe.name
										} - ${lihe.station}" src="" />
                    <iframe type="text/html" width="100%" height="100%" style="display:none;" class="right-iframe" src=""></iframe>
                </div>
            </div>
        
            <div class="slide-btn slide-left rounded-circle position-absolute cursor-pointer">
                <button class="rounded-circle  d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 19L8 12L15 5" stroke="#1D2329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                </button>
            </div>
            <div class="slide-btn slide-right rounded-circle position-absolute cursor-pointer">
                <button class="rounded-circle d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 5L16 12L9 19" stroke="#1D2329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                </button>
            </div>
            <div class="slide-count position-absolute">
                <div class="py-2 px-3 caption-default">
                    <span class="current-slide"></span>
                    <span>/</span>
                    <span class="total-slides"></span>
                </div>
            </div>
        </div>
    `;
	}

	#getRequiredSliderHeight() {
		const settings =
			Object.keys(this.#data.customHeightSettings).length > 0
				? this.#data.customHeightSettings
				: this.#defaultHeightSettings;
		if (window.screenSizeManager.screenType === "mobile")
			return settings["mobile"];
		else return settings["tablet"];
	}

	#getRootDiv() {
		return this.#rootDiv ?? document.querySelector(this.#rootDivSelector);
	}

	#getTransition() {
		const animationSpeed = this.#isNeedQuickAnimation()
			? this.#data.quickAnimationSpeed
			: this.#data.animationSpeed;
		return `all ${animationSpeed}ms ease-in-out`;
	}

	#getTranslate3d(int) {
		return `translate3d(-${Math.abs(int)}px, 0px, 0px)`;
	}

	#getCurrentTranslate3d() {
		const sliderList = this.#getSliderList();
		const regex = /\d, \d, \d, \d, (-?\d+), \d/;
		const transformString = window.getComputedStyle(sliderList).transform;
		const match = transformString.match(regex);
		const currentTranslateValString = match ? match[1] : this.#getRootWidth();
		return parseInt(currentTranslateValString);
	}

	#getSliderList() {
		return this.#getRootDiv().querySelector(".slider-list") || undefined;
	}
	#getSliderListWrapper() {
		return this.#getRootDiv().querySelector(".slider-list-wrapper");
	}
	#getRootWidth() {
		return parseInt(window.getComputedStyle(this.#getRootDiv())["width"]);
	}

	#getImg(type) {
		const selectors = {
			left: ".left-img",
			right: ".right-img",
			main: ".main-img",
		};
		return this.#getRootDiv().querySelector(selectors[type]);
	}

	#getIframe(type) {
		const selectors = {
			left: ".left-iframe",
			right: ".right-iframe",
			main: ".main-iframe",
		};
		return this.#getRootDiv().querySelector(selectors[type]);
	}

	#setImg(type, src) {
		const imgElem = this.#getImg(type);
		const iframeElem = this.#getIframe(type);
		imgElem.src = src;
		imgElem.style.display = "block";
		iframeElem.src = "";
		iframeElem.style.display = "none";
	}

	#setIframe(type, src) {
		const imgElem = this.#getImg(type);
		const iframeElem = this.#getIframe(type);
		imgElem.src = "";
		imgElem.style.display = "none";
		iframeElem.src = src;
		iframeElem.style.display = "block";
	}

	#setSlides(mainIndex) {
		// for an index, set three slides' sources according to source type (img or iframe)
		const leftSrcObj =
			this.#data.srcObjectArray[this.#getNextSlideIndex(mainIndex, "left")];
		const mainSrcObj = this.#data.srcObjectArray[mainIndex];
		const rightSrcObj =
			this.#data.srcObjectArray[this.#getNextSlideIndex(mainIndex, "right")];
		if (leftSrcObj.type === "image") {
			this.#setImg(
				"left",
				leftSrcObj.imgMedium ||
					leftSrcObj.imgLarge ||
					leftSrcObj.imgXL ||
					leftSrcObj.imgSmall ||
					leftSrcObj.img
			);
		} else {
			this.#setIframe("left", "");
		}
		if (mainSrcObj.type === "image") {
			this.#setImg(
				"main",
				mainSrcObj.imgMedium ||
					mainSrcObj.imgLarge ||
					mainSrcObj.imgXL ||
					mainSrcObj.imgSmall ||
					mainSrcObj.img
			);
		} else {
			this.#setIframe("main", this.#youtubeUrl + mainSrcObj.src);
		}
		if (rightSrcObj.type === "image") {
			this.#setImg(
				"right",
				rightSrcObj.imgMedium ||
					rightSrcObj.imgLarge ||
					rightSrcObj.imgXL ||
					rightSrcObj.imgSmall ||
					rightSrcObj.img
			);
		} else {
			this.#setIframe("right", "");
		}

		this.#data.mainSrcIndex = mainIndex;

		this.adjust();
	}

	#getNextSlideIndex(index, direction) {
		if (direction === "main") return index;

		const diff = direction === "left" ? -1 : 1;
		const preliminaryNextImgIndex = index + diff;
		let finalNextImgIndex = preliminaryNextImgIndex;
		if (preliminaryNextImgIndex < 0) {
			finalNextImgIndex = this.#data.srcObjectArray.length - 1;
		}
		if (preliminaryNextImgIndex >= this.#data.srcObjectArray.length) {
			finalNextImgIndex = 0;
		}
		return finalNextImgIndex;
	}

	#getNewTranslate3dVal(direction) {
		switch (direction) {
			case "left":
				return 0;
			case "right":
				return this.#getRootWidth() * 2;
			default:
				return this.#getRootWidth();
		}
	}

	async #animate(direction = undefined, newSlideIndex = undefined) {
		if (this.#state.isAnimating) return;

		direction = !direction ? this.#getDirection() : direction;
		try {
			const sliderList = this.#getSliderList();
			const newTranslate3dVal = this.#getNewTranslate3dVal(direction);

			// action
			const newTransform = this.#getTranslate3d(newTranslate3dVal);
			sliderList.style.transition = this.#getTransition();

			const newIndex =
				newSlideIndex ??
				this.#getNextSlideIndex(this.#data.mainSrcIndex, direction);
			this.#setCurrentSlideNumber(newIndex + 1);
			// cleanup
			const transitionEndFunc = () => {
				this.#setSlides(newIndex);
				sliderList.style.transition = "initial";
				sliderList.style.transform = this.#getTranslate3d(this.#getRootWidth());
				sliderList.removeEventListener("transitionend", transitionEndFunc);
				this.#displayControlsForCurrentSlide();
				this.#setCurrentSlideNumber(newIndex + 1);
			};

			sliderList.addEventListener("transitionend", transitionEndFunc, {
				passive: true,
			});
			sliderList.style.transform = newTransform;
		} catch (e) {
			console.error(e);
		}
	}

	#recheckIsAnimating(direction = "main") {
		const sliderList = this.#getSliderList();
		const newTranslate3dVal = this.#getNewTranslate3dVal(direction);
		const newTransform = this.#getTranslate3d(newTranslate3dVal);
		if (sliderList.style.transform === newTransform)
			this.#state.isAnimating = false;
	}

	// START - CONTROLS DISPLAY
	#setSlideControlsDisplay(display) {
		this.#setSlideControlsDisplay_arrows(display);
		this.#setSlideControlsDisplay_total(display);
	}

	#setSlideControlsDisplay_arrows(display) {
		Array.from(this.#getRootDiv().querySelectorAll(".slide-btn")).forEach(
			(btn) => {
				btn.style.display = display;
			}
		);
	}

	#setSlideControlsDisplay_total(display) {
		Array.from(this.#getRootDiv().querySelectorAll(".slide-count")).forEach(
			(btn) => {
				btn.style.display = display;
			}
		);
	}

	#displayControlsForCurrentSlide() {
		if (this.#data.srcObjectArray[this.#data.mainSrcIndex].type === "image") {
			this.#setSlideControlsDisplay("block");
		} else {
			this.#setSlideControlsDisplay_arrows("block");
			this.#setSlideControlsDisplay_total("none");
		}
	}
	// END - CONTROLS DISPLAY

	#getDirection() {
		// if quick touch drag detected - ensure slide to left or right
		// if drag wasn't quick - allow for return to main slide (with multipliers)
		const quick = this.#isNeedQuickAnimation();
		const leftMultiplier = quick ? 1 : 0.5;
		const rightMultiplier = quick ? 1 : 1.5;

		const currentTranslateVal = Math.abs(this.#getCurrentTranslate3d());

		// ignore tiny movements, only react to > 0.5% of image width
		const percScrolled =
			(currentTranslateVal - this.#getRootWidth()) / this.#getRootWidth();
		if (percScrolled < 0.005 && percScrolled > -1 * 0.005) return "main";

		if (currentTranslateVal < this.#getRootWidth() * leftMultiplier) {
			return "left";
		} else if (currentTranslateVal > this.#getRootWidth() * rightMultiplier) {
			return "right";
		} else {
			return "main";
		}
	}

	#isNeedQuickAnimation() {
		return (
			this.#data.endActionTimestamp - this.#data.startActionTimestamp <=
			this.#data.animationSpeed
		);
	}

	#initializeWidthAndHeightAdjustmentListener() {
		// This throttles the event listener. Responding to each resize event is awful for performance. Instead it responds only every fixed period of time (200ms)
		const adjustWidth = () => {
			window.removeEventListener("resize", adjustWidth);
			this.adjust();
			setTimeout(() => {
				window.addEventListener("resize", adjustWidth, { passive: true });
			}, 100);
		};
		window.addEventListener("resize", adjustWidth, { passive: true });
	}

	#setSliderListeners() {
		const sliderList = this.#getSliderList();

		this.#initializeWidthAndHeightAdjustmentListener();

		// function to get X position of event (different for touch events)
		const getX = (ev) => {
			if (["touchstart", "touchmove", "touchend"].includes(ev.type)) {
				return ev.touches[0].pageX;
			} else {
				return ev.pageX;
			}
		};

		// set slider manipulation events
		[
			["touchstart", "touchmove", "touchend"],
			["mousedown", "mousemove", "mouseup"],
			["dragstart", "drag", "dragend"],
		].forEach(([startEventString, moveEventString, endEventString]) => {
			// start event listener
			sliderList.addEventListener(
				startEventString,
				(startEvent) => {
					this.#recheckIsAnimating();
					if (this.#state.isAnimating) return;

					const currentTimestamp = Date.now();
					const rootWidth = this.#getRootWidth();
					this.#data.startActionTimestamp = currentTimestamp;
					setTimeout(() => {
						// hide controls with some delay
						if (
							this.#data.startActionTimestamp === currentTimestamp &&
							this.#data.endActionTimestamp < currentTimestamp
						) {
							this.#setSlideControlsDisplay("none");
						}
					}, 150);
					const initialX = getX(startEvent);
					let currentX = initialX;

					// move event handler
					const moveFunc = (moveEvent) => {
						currentX = getX(moveEvent);
						const distanceTraveled = currentX - initialX;
						let newTranslateVal = parseInt(rootWidth - distanceTraveled);
						const newTransform = this.#getTranslate3d(newTranslateVal);
						sliderList.style.transform = newTransform;
					};
					// end event handler
					const endFunc = async () => {
						sliderList.removeEventListener(moveEventString, moveFunc);
						sliderList.removeEventListener(endEventString, endFunc);
						this.#data.endActionTimestamp = Date.now();
						await this.#animate();
						this.#displayControlsForCurrentSlide();
					};

					sliderList.addEventListener(moveEventString, moveFunc);
					sliderList.addEventListener(endEventString, endFunc);
				},
				{ passive: true }
			);
		});

		sliderList.addEventListener(
			"transitionstart",
			() => (this.#state.isAnimating = true),
			{ passive: true }
		);
		sliderList.addEventListener(
			"transitionend",
			() => (this.#state.isAnimating = false),
			{ passive: true }
		);

		// disable certain events
		["dragstart", "drag", "selectstart"].forEach((ev) => {
			this.#getSliderList().addEventListener(ev, (e) => {
				e.preventDefault();
				return false;
			});
			this.#getImg("left").addEventListener(ev, (e) => {
				e.preventDefault();
				return false;
			});
			this.#getImg("main").addEventListener(ev, (e) => {
				e.preventDefault();
				return false;
			});
			this.#getImg("right").addEventListener(ev, (e) => {
				e.preventDefault();
				return false;
			});
		});

		// control buttons
		["left", "right"].forEach((side) => {
			this.#getRootDiv()
				.querySelector(`.slide-${side}`)
				.addEventListener(
					"click",
					async () => {
						this.#recheckIsAnimating();
						this.#data.startActionTimestamp = this.#data.endActionTimestamp;
						this.#data.endActionTimestamp = Date.now();
						await this.#animate(side);
					},
					{ passive: true }
				);
		});

		// adjust sizes one time, when images load
		const once = true;
		this.#getSliderList()
			.querySelectorAll("img")
			.forEach((img) => {
				img.addEventListener(
					"load",
					() => {
						this.adjust();
						this.#getRootDiv().querySelector(
							".mobile-slider-wrapper"
						).style.visibility = "visible";
					},
					once
				);
			});
	}

	//   Add zero to num if it is one digit
	#formatSlideNumber(num) {
		if (typeof num === "undefined")
			throw new Error("no slide number provided in formatSlideNumber");
		const stringifiedNumber = num.toString();
		if (stringifiedNumber.length < 2) return `0${stringifiedNumber}`;

		return stringifiedNumber;
	}

	#setCurrentSlideNumber(num) {
		this.#getRootDiv().querySelector(".current-slide").innerHTML =
			this.#formatSlideNumber(num);
	}

	#setTotalSlides() {
		const totalSlideNumber = this.#data.srcObjectArray.length;
		this.#getRootDiv().querySelector(".total-slides").innerHTML =
			this.#formatSlideNumber(totalSlideNumber);
	}

	#injectSliderHTML() {
		this.#getRootDiv().innerHTML = "";
		this.#getRootDiv().insertAdjacentHTML(
			"afterbegin",
			this.#getGalleryMobileTemplate()
		);
	}

	// public methods
	init() {
		this.#injectSliderHTML();

		this.#setSliderListeners();

		this.#setSlides(0);
		this.#setCurrentSlideNumber(1);
		this.#setTotalSlides();

		this.adjust();
	}

	async triggerSlide(direction) {
		await this.#animate(direction);
	}

	async slideToImage(toImage_No) {
		if (toImage_No === this.#data.mainSrcIndex) return;
		const direction = toImage_No < this.#data.mainSrcIndex ? "left" : "right";
		await this.#animate(direction, toImage_No);
	}

	adjust() {
		this.#getSliderListWrapper().style.height = `${this.#getRequiredSliderHeight()}px`;
		Array.from(this.#getSliderList().querySelectorAll("img, iframe")).forEach(
			(elem) => {
				elem.style.width = `${this.#getRootWidth()}px`;
				elem.style.height = `100%`;
			}
		);
		const sliderList = this.#getSliderList();
		sliderList.style.transition = "initial";
		sliderList.style.transform = this.#getTranslate3d(this.#getRootWidth());
	}
}
